import styled from '@emotion/styled';
import {
	ArrowIconLight,
	Css,
	ExternalLinkIconLight,
	ILinkItemType,
	Responsive,
	StyledCard,
} from '@/ui';
import React, { ReactNode } from 'react';
import LinkButton from '../../button/LinkButton';
import { PageRoutes } from '../../../../features/app/pages/domain/constants/PageRoutes';
import { Shadow } from '../../../../styles/Shadow';
import { getHeadingStyle } from '../../../../styles/utils/getHeadingStyle';
import { theme } from '../../../../styles/theme';

interface IContentCardProps {
	title: string;
	body?: ReactNode | string;
	buttonLabel?: string;
	buttonLink?: string;
	linkType?: ILinkItemType;
}

export default function ContentCard({
	title,
	body,
	buttonLabel,
	buttonLink,
	linkType,
}: IContentCardProps) {
	return (
		<ContentCardStyled>
			<CardTitle>{title}</CardTitle>
			<CardBody>{body}</CardBody>
			{buttonLink && (
				<CardButton>
					<LinkButton
						href={buttonLink || PageRoutes.Home}
						aria-label={buttonLabel}
						icon={
							linkType === 'external-link' ? (
								<ExternalLinkIconLight />
							) : (
								<ArrowIconLight />
							)
						}
						{...(linkType === 'external-link'
							? { target: '_blank', rel: 'noopener noreferrer' }
							: {})}
					>
						{buttonLabel}
					</LinkButton>
				</CardButton>
			)}
		</ContentCardStyled>
	);
}

const ContentCardStyled = styled(StyledCard)`
	padding: ${Css.pxToRemFromTheme(32)};
	margin: 0;
	box-shadow: ${Shadow.ExtraLarge};

	a {
		text-decoration: none;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding: ${Css.pxToRemFromTheme(16)};
	}
`;

const CardBody = styled.div`
	font-size: ${Css.pxToRemFromTheme(18)};
	margin-top: ${Css.pxToRemFromTheme(8)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		font-size: ${Css.pxToRemFromTheme(16)};
	}
`;

const CardButton = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-top: ${Css.pxToRemFromTheme(24)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-top: ${Css.pxToRemFromTheme(16)};
	}
`;

const CardTitle = styled.h3`
	${getHeadingStyle(theme, 'h6')}
`;
